import { useEffect, useState } from "react";

// Discreet mobile-only sticky CTA that appears after the hero.
export const StickyCta = () => {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > window.innerHeight * 0.85);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div
      data-testid="mobile-sticky-cta"
      className={`md:hidden fixed bottom-0 inset-x-0 z-40 p-3 bg-[#FAF9F6]/95 backdrop-blur-xl border-t border-[#EAE8E3] transition-transform duration-300 ${show ? "translate-y-0" : "translate-y-full"}`}
    >
      <a href="/#devis" data-testid="mobile-sticky-cta-link"
        className="block text-center text-[11px] uppercase tracking-[0.24em] bg-[#1A1B18] text-[#FAF9F6] px-5 py-4">
        Créer mon voyage sur-mesure
      </a>
    </div>
  );
};

export default StickyCta;
